import { Component, Inject, OnInit } from '@angular/core';
import { CalcsService } from '../calcs.service';
import jspdf from 'jspdf';
import autoTable from 'jspdf-autotable'

@Component({
  selector: 'app-repayment-input',
  templateUrl: './repayment-home.component.html',
  styleUrls: ['./repayment-home.component.css'],
  providers: [
    { provide: 'Window',  useValue: window }
  ]
})
export class RepaymentHomeComponent implements OnInit {
  
  constructor(
    @Inject('Window') private window: Window,
    public calcService: CalcsService) { }

  ngOnInit(): void {
    // this.export()
  }

  export() {

    const margin = 20
    const currency = '£'
    const locale = 'en-GB'

    //Inputs
    const propertyValue = currency + this.calcService.rm.originalPropertyVal.toLocaleString(locale)
    const depositAmount = currency + (this.calcService.rm.originalPropertyVal * (this.calcService.rm.depositVal /100)).toLocaleString(locale)
    const term = this.calcService.rm.loanTerm + ' years'
    const initialTerm = this.calcService.rm.initialTerm + ' years'
    const interestRate = (this.calcService.rm.interestRate * 100).toLocaleString(locale) + '%'
    const fee = currency + this.calcService.rm.mortgageFee.toLocaleString(locale)
    const cb = currency + this.calcService.rm.cbAmt.toLocaleString(locale)
    const property = this.calcService.rm.propertyType

    const inputs = [
      { label: 'Original Property Value:', value: propertyValue },
      { label: 'Deposit Amount:', value: depositAmount + ' ('+this.calcService.rm.depositVal+'%)'},
      { label: 'Loan Term:', value: term },
      { label: 'Initial Term:', value: initialTerm },
      { label: 'Interest Rate:', value: interestRate },
      { label: 'Mortgage Fee:', value: fee },
      { label: 'Cashback:', value: cb },
      { label: 'Property Type:', value: property },
    ]

    //Breakdown
    const loanAmount = currency + this.calcService.getLoanAmount().toLocaleString(locale)
    const monthlyPmt = currency + this.calcService.getMonthlyPayment().toFixed(2)
    const monthlyIncrease = currency + this.calcService.getMonthlyFeeImpact().toFixed(2)
    const startLtv = (this.calcService.getOriginalLTV() * 100).toFixed(2) + '%'

    const breakdown = [
      { label: 'Loan Amount:', value: loanAmount },
      { label: 'Monthly Payment:', value: monthlyPmt },
      { label: 'Monthly Increase from fee:', value: monthlyIncrease },
      { label: 'Starting LTV:', value: startLtv },
    ]

    //Overpayments & HPI
    const overpayment = currency + this.calcService.rm.extraPmt.toLocaleString(locale)
    const totalPayment = currency + (this.calcService.rm.extraPmt + this.calcService.calcPmt()).toFixed(2)
    const interestSaved = currency + this.calcService.calcInterestSaved().toFixed(2)
    const yearsSaved = (this.calcService.calcNumPaymentsSaved() / 12).toFixed(2)
    const newLTV = (this.calcService.calcLtv() * 100).toFixed(2) + '%'
    const assumedHPI = (this.calcService.rm.hpiVal * 100).toFixed(2) + '%'

    const extra = [
      { label: 'Monthly Overpayment:', value: overpayment },
      { label: 'Total Monthly Payment:', value: totalPayment },
      { label: 'Total Interest Saved:', value: interestSaved },
      { label: 'Total Years Saved:', value: yearsSaved },
      { label: 'New LTV in '+this.calcService.rm.initialTerm + ' years:', value: newLTV },
      { label: 'Assumed annual HPI increase based on a '+this.calcService.rm.propertyType + ' property:', value: assumedHPI },
    ]

    var doc = new jspdf();
    doc.setFont('Helvetica')
    doc.setFontSize(12)

    var img = new Image() 
    img.src = '../assets/main-logo-dark.png'
    doc.addImage(img, 'png', margin, margin, 40, 20)

    doc.setFont(undefined, 'bold')
    doc.text('Mortgage Inputs', margin, 55)
    doc.setLineWidth(0.5)
    doc.line(margin, 60, 100, 60)

    const inputsStart = 70
    for (let i = 0; i < inputs.length; i++) {
      doc.setFont(undefined, 'normal')
      doc.text(inputs[i].label + ' ' + inputs[i].value, margin, inputsStart + (i * 5))
    }

    doc.setFont(undefined, 'bold')
    doc.text('Loan Breakdown', margin, inputsStart + (inputs.length * 6))
    doc.setLineWidth(0.5)
    doc.line(margin, inputsStart + (inputs.length * 6) + 5, 100, inputsStart + (inputs.length * 6) + 5)

    const breakdownStart = inputsStart + (inputs.length * 6) + 15
    for (let i = 0; i < breakdown.length; i++) {
      doc.setFont(undefined, 'normal')
      doc.text(breakdown[i].label + ' ' + breakdown[i].value, margin, breakdownStart + (i * 5))
    }

    doc.setFont(undefined, 'bold')
    doc.text('Overpayments & HPI', margin, breakdownStart + (breakdown.length * 7))
    doc.setLineWidth(0.5)
    doc.line(margin, breakdownStart + (breakdown.length * 7) + 5, 100, breakdownStart + (breakdown.length * 7) + 5)

    const extraStart = breakdownStart + (breakdown.length * 6) + 15
    for (let i = 0; i < extra.length; i++) {
      doc.setFont(undefined, 'normal')
      doc.text(extra[i].label + ' ' + extra[i].value, margin, extraStart + (i * 5))
    }
    
    doc.addPage()

    doc.setFont(undefined, 'bold')
    doc.text('Repayment Schedule', margin, 20)

    let tableRows = []

    let schedule = this.calcService.getSchedule()
    for (let i = 0; i < schedule.length; i++) {
      delete schedule[i]['prinBalPreExtra']
      delete schedule[i]['propertyValue']

      schedule[i]['intPmt'] = '£'+ schedule[i]['intPmt'].toFixed(0)
      schedule[i]['ltv'] = (schedule[i]['ltv'] * 100).toFixed(0) + '%'
      schedule[i]['extraPmt'] = '£'+ (schedule[i]['extraPmt']).toFixed(0)
      schedule[i]['pmt'] = '£'+ (-schedule[i]['pmt']).toFixed(0)
      schedule[i]['prinBalPostExtra'] = '£'+ schedule[i]['prinBalPostExtra'].toFixed(0)
      // schedule[i]['prinBalPreExtra'] = '£'+ schedule[i]['prinBalPreExtra'].toFixed(0)
      schedule[i]['prinPmt'] = '£'+ schedule[i]['prinPmt'].toFixed(0)
      // schedule[i]['propertyValue'] = '£'+ schedule[i]['propertyValue'].toFixed(0)
    }
    
    schedule.forEach((e,i) => {
      const row = Object.values(e)

      row.forEach((f) => {
        const value = f
        // console.log(value)
      })
      tableRows.push(row)
    })

    autoTable(doc, { 
      head: [['Period', 'Total Payment', 'Interest','Principal','Over Payment','Balance Post OP','Projected LTV']],
      body: tableRows,
      tableWidth: 'wrap',
      margin: { top: 30, left:20, right:20 },
      styles: {
        cellWidth: 24.5
      }
    })
    // doc.output('dataurlnewwindow');
    doc.save('Mortgage Calculator Output.pdf')
  }
}

